module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-engagements-icon-tested-derma.6f7c2d9c.svg";